import {Injectable}					      from '@angular/core';
import {Http, Response}				    from '@angular/http';
import {Headers, RequestOptions}	from '@angular/http';
import {ContentNode}				      from './content-node';
import {Observable}					      from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
//import 'rxjs/add/operator/publish';
import { environment } from '../environments/environment';
import { ConfigService } from './config.service';


@Injectable()
export class ContentService {
	constructor(private http: Http, private configService: ConfigService) {}

	public _config = this.configService.getConfiguration();
    public _contentNodesUrl = //'http://localhost:54432/govil/apps/he/kabaut/shalhevet/';
		this._config.webApiBaseUrl;
	public _isTestData = this._config.isTestData;

	contentNodes: ContentNode[];

	getContentNodes (parentId:string, isRoot:boolean, catId:string) {
		console.log('parentId = ' + parentId);
		debugger;
		if (true || isRoot){
			return this.http.get(this._contentNodesUrl + catId + (this._isTestData ? '/Test' :''))
				.map(res => (this.contentNodes = 
					<ContentNode[]> res.json()).filter(
					(node,ix,nodes)=>{
						var parts = node.CATEGORY_CODE.split('.');
						var parts2 = node.CATEGORY_CODE.split(' ');
                        return parts[0] != '' && (parts.length == 1 || node.PARENT_CATEGORY_CODE == null) &&
                            (parts2.length == 1  /*This is added because of Ganei Eruim 
                            (Also: Hebrew text here (for Ganei Eruim) will cause error in IE)*/
								|| parts2[parts2.length-1] ==''/*because of "07.02 "*/) &&
							(node.PARENT_CATEGORY_CODE == '' || node.PARENT_CATEGORY_CODE == null);
					}))
				.do(data => {
					console.log(data);
					//this.contentNodes = data; 
				})
				.catch(this.handleError);
		

		}
			

	}

	getChildNodes(parentCode: string){
		return this.contentNodes.filter((node,ix,nodes)=>{
						return node.PARENT_CATEGORY_CODE == parentCode;
					});
	}

	private handleError (error: Response) {
		console.error(error);
		return Observable.throw(error.json().error || 'Server error');
	}
}


// WEBPACK FOOTER //
// ./src/app/content.service.ts